import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhone,faCalendar,faUsers,faHeart} from '@fortawesome/free-solid-svg-icons'

library.add(fab,faMapMarkerAlt,faPhone,faCalendar,faUsers,faHeart);